module.exports = __webpack_public_path__ + "static/Help Juice-096df58f547fd293c9284adbbf4700a9.png";